import angular from 'angular'
import './channel_group.service'
import './channel/channel.controller'
import './channel/channel.service'

angular
  .module('admin.channel_group', ['admin.channel_group.service', 'admin.channel_group_children'])
  .controller('ChannelGroupAdminCtrl', ChannelGroupAdminCtrl)

/** @ngInject */
function ChannelGroupAdminCtrl($scope, $state, $stateParams, ChannelGroupService, UploadService) {
  var vm = this
  vm.items = []
  vm.pathImgT = ''
  vm.create = false
  vm.model = {}
  vm.totalUsers = 0
  vm.usersPerPage = 25
  vm.oldPage = 0
  vm.currentPage = 25
  vm.first = true
  vm.totalItems = 0
  vm.pagination = {
    current: 1,
  }
  vm.model = {}

  vm.sortType = 'n-asc'
  vm.sortReverse = false

  load(1)

  var oldSortType
  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)
    ChannelGroupService.list(vm.oldPage, 25, vm.sortType).then(function(result) {
      var channels = result.results
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      for (var i = 0; i < channels.length; i++) {
        if (pageNumber === 1 && i === 0) {
          channels[i].firstRow = true
        }

        if (channels.length - 1 === i && channels.length < vm.currentPage) {
          channels[i].lastRow = true
        }
        channels[i].editing = false
      }

      vm.sortType = oldSortType
      vm.items = channels
      vm.disableTable = false
    })
  }

  vm.pageChanged = function(newPage) {
    vm.sortType = oldSortType
    load(newPage)
  }

  vm.add = function() {
    $state.go('admin.channel_group.children', { parentId: null })
  }

  vm.edit = function(item) {
    $state.go('admin.channel_group.children', { parentId: item.id })
  }

  vm.save = function(item) {
    vm.create = false
    if (item.id !== undefined && item.id !== '' && item.id !== 0) {
      ChannelGroupService.update(item.id, item).then(function() {
        load(vm.pagination.current)
      })
    } else {
      delete item.id
      delete item.editing
      ChannelGroupService.save(item).then(function() {
        load(vm.pagination.current)
      })
    }
  }

  vm.cancel = function(item) {
    if (item.id === 0) {
      vm.items.remove(item)
    }
    item.editing = !item.editing
    vm.create = false
  }

  vm.delete = function(item) {
    swal(
      {
        title: 'Are you sure ?',
        text: 'You want delete this channel group',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          ChannelGroupService.remove(item.id).then(
            function() {
              if (vm.items.length === 1 || vm.items.length === 25) {
                $state.reload()
              } else {
                load(vm.pagination.current)
              }
            },
            function() {
              swal('You cannot delete a channel group because has channels associated', '', 'error')
            },
          )
        }
      },
    )
  }

  vm.remove = function() {
    $('#myModal').modal('hide')
  }

  vm.publish = function(item) {
    ChannelGroupService.publish(item.id).then(function() {
      load(vm.pagination.current)
    })
  }

  vm.unpublish = function(item) {
    ChannelGroupService.unpublish(item.id).then(function() {
      load(vm.pagination.current)
    })
  }

  vm.back = function() {
    load(vm.pagination.current)
  }

  vm.showDescription = function(item) {
    $('#myModal').modal('show')
    $('#myModal').on('shown.bs.modal', function() {
      $('#description').text(item)
    })
  }

  vm.arrowUp = function(item) {
    var copy = angular.copy(item)
    copy.n = copy.n - 1
    ChannelGroupService.update(copy.id, { n: copy.n }).then(function() {
      load(vm.pagination.current)
    })
  }

  vm.arrowDown = function(item) {
    var copy = angular.copy(item)
    copy.n = copy.n + 1
    ChannelGroupService.update(copy.id, { n: copy.n }).then(function() {
      load(vm.pagination.current)
    })
  }

  vm.disableTable = false
  vm.barConfig = {
    animation: 150,
    ghostClass: 'ghost',
    onEnd: function(/** ngSortEvent */ evt) {
      vm.disableTable = true
      vm.orderList(evt)
    },
  }

  vm.orderList = function(evt) {
    for (var i = 0; i < vm.items.length; i++) {
      vm.items[i].o = parseInt(evt.newIndex) + 1
      if (vm.items[i].id === evt.model.id) {
        vm.update(evt.model)
      }
    }
  }

  vm.update = function(model) {
    ChannelGroupService.update(model.id, { n: model.o }).then(function() {
      load(vm.pagination.current)
    })
  }

  vm.uploadT = function(item) {
    item.loadT = true
    UploadService.save('channel_groups', vm.pathImgT, 'img-t', item.id).then(function(fileName) {
      item.loadT = false
      item['img-t'] = fileName
    })
  }

  vm.uploadT2 = function() {
    vm.loadT = true
    UploadService.save('channel_groups', vm.pathImgT, 'img-t', 0).then(function(fileName) {
      vm.loadT = false
      vm.model['img-t'] = fileName
    })
  }

  vm.selectImage = function() {
    $('#myModal').modal('hide')
    ChannelGroupService.save(vm.model).then(function(result) {
      $state.go('admin.channel_group.children', { parentId: result.results.id })
    })
  }

  vm.sort = function(type) {
    vm.sortReverse = !vm.sortReverse
    if (vm.sortReverse) {
      vm.sortType = type + '-asc'
    } else {
      vm.sortType = type + '-desc'
    }
    load(1)
  }
}
